import { VerifierCredentialStatus } from 'src/api';

export enum DashboardTab {
  Global = 'Global',
  Verifiers = 'Verifiers',
  Financial = 'Financial Data Access',
}

export type OverviewCredentialedVerifiers = Record<
  typeof VerifierCredentialStatus.Credentialed | typeof VerifierCredentialStatus.NotCredentialed,
  number
>;

export type OverviewTotalVerifications = Record<'auto' | 'manual', number>;

export type OverviewManualRequestsActivity = Record<'approved' | 'declined' | 'pending', number>;
